<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 模块1 -->

    <div class="box-content">
      <div class="content-one">
        <p class="return-button" @click="goBack">
          返回 <el-icon><ArrowRight /></el-icon>
        </p>
        <p>
          {{ mydata.messageInfoObj.title }}
          <!-- 有人说:“老师是座灯塔，为我们照亮前方的道路;老师像只蜡烛，燃烧了自己，却成为照亮别人的人。”还有人说:“老师是辛勤的园丁，用自己的心血和汗水浇灌着我们。 -->
        </p>
        <P>
          <span style="margin-right: 34px"
            >发送时间：
            {{ mydata.messageInfoObj.create_time }}
            <!-- {{
              dayjs(mydata.messageInfoObj.create_time * 1000).format(
                "YYYY-MM-DD"
              )
            }} -->
          </span>

          <!-- <span style="margin-right: 34px"
            >来源：{{ mydata.messageInfoObj.source }}</span
          > -->
          <!-- <span
            >关键词：
            <span
              v-for="(item, index) in mydata.messageInfoObj.tags"
              :key="index"
              style="margin-right:10px;"
              >{{ item.name }}</span
            >
          </span> -->
        </P>

        <p class="tableA" v-html="mydata.messageInfoObj.message"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";

import { reactive, toRefs, inject } from "vue";

import imgBigCards from "@/components/imgBigCards/index.vue";

import { ChatDotSquare, ArrowRight } from "@element-plus/icons-vue";

import dayjs from "dayjs";

// 引入接口
import {
  messageInfo,
  unreadMessage,
} from "@/api/personalCenter/myNotifications/index.js";
import { useStore } from "vuex"
const store = useStore()

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
  textarea: "",

  messageId: null, // 消息id值
  messageInfoObj: {}, // 消息详情

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
});

const { circleUrl, sizeList } = toRefs(mydata);


// 初始化函数
function init() {
  // 获取到传递过来的参数
  mydata.messageId = route.query.id;
  // 调用接口获取文章详情
  messageInfo({ id: mydata.messageId }).then((res) => {
    // console.log(res.data, "站内信息详情");
    mydata.messageInfoObj = res.data;
    //未读消息
    unreadMessage().then((res) => {
        store.commit('set_unreadCount',res.data.count)
    });
  });
}

init();

function goBack() {
  window.history.back();
}
</script>












<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;

  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //////内容部分
  .box-content {
    // width: 1200px;
    margin: 0 auto;
    margin-top: 16px;

    //第一个模块
    .content-one {
      // width: 860px;
      background-color: #ffffff;
      padding: 20px 16px;

      .return-button {
        margin-left: -5px;
        margin-top: -10px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 14px;
        color: #333333;
      }
      .return-button:hover {
        color: #009de0;
      }

      > p:nth-of-type(2)  {
        min-height: 28px;
        font-size: 18px;
        font-weight: 700;
        color: #333333;

        line-height: 28px;
        // height: 56px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
      }
      > p:nth-of-type(3) {
        display: flex;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #888888;
        margin-top: 12px;
         margin-bottom: 24px;
        > span {
          margin-right: 13px;
        }
      }

      > p:last-of-type {
        // margin-top: 24px;
        // white-space: pre-wrap;
        // font-size: 14px;
        // font-weight: 400;
        // color: #333333;
        // line-height: 24px;
        // word-break: break-all;
        // border:1px solid red;
      }
    }

    //第二个
    .content-two {
      // height: 465px;
      margin-top: 20px;
      padding: 30px;
      background-color: #ffffff;
      // border:1px solid red;
      .a-title {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 30px;
      }
      //头像盒子
      .person-head {
        // height: 170px;
        background-color: #ffffff;
        overflow: hidden;
        display: flex;
        align-items: center;
        // border: 1px solid red;
        // margin-top: 30px;
        ////////头像样式
        :deep(.el-row.demo-avatar.demo-basic) {
          width: 52px;
          height: 52px;
          // border: 1px solid red;
          // 头像框
          .demo-basic--circle {
            width: 52px;
            height: 52px;
            // border:1px solid red;
          }
          //头像框
          .block {
            width: 52px;
            height: 52px;
            // border:1px solid red;
          }
          //圆头像
          .el-avatar.el-avatar--circle {
            width: 52px;
            height: 52px;
            // border: 1px solid blue;
          }
        }

        > p {
          font-size: 16px;
          font-weight: 500;
          color: #b4b4b4;
          margin-left: 10px;
        }
      }

      //消息
      .person-news {
        // border: 1px solid red;
        margin-left: 62px;
        //title
        > p:first-of-type {
          font-size: 14px;
          font-weight: 400;
          color: #333333;

          line-height: 22px;
          // height: 56px;
          display: -webkit-box;
          -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
          text-overflow: ellipsis; //文本溢出 用省略号显示
          -webkit-line-clamp: 2; //几行
          overflow: hidden;
        }

        //时间
        .box-time {
          font-size: 14px;
          font-weight: 400;
          color: #888888;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
          // border:1px solid blue;
          > p:first-of-type {
            > span {
              margin-right: 13px;
            }
          }
          > p:last-of-type {
            display: flex;
            align-items: center;
            :deep(.el-icon) {
              font-size: 20px;
              font-weight: 400;
            }
          }
        }
        //文本框
        :deep(.el-textarea__inner) {
          height: 137px;
          margin-top: 22px;
          border-radius: 8px;
        }
        //按钮
        .box-button {
          width: 100%;
          height: 27px;
          // border:1px solid rgb(38, 0, 255);
          margin-top: 12px;
          position: relative;

          :deep(.el-button.el-button--primary) {
            //  border:1px solid red;
            width: 84px;
            height: 27px;
            border-radius: 8px;
            position: absolute;
            right: 0px;
          }
        }
      }
    }
  }
}
</style>